// Server-side pagination kept in sync with the route query (?count=20&page=1).
// Filters named in `routeFilterKeys` (default: search_param) also live in the query
// and are forwarded to the API. The component must implement fetchPage({count, page, ...filters}).
const DEFAULT_COUNT = 20;
const SEARCH_DEBOUNCE_MS = 400;

const toPositiveInt = (value, fallback) => {
    const n = parseInt(value, 10);
    return n > 0 ? n : fallback;
};

export default {
    data() {
        return {
            currentPage: 1,
            perPage: DEFAULT_COUNT,
            pageOptions: [20, 50, 100],
            routeFilterKeys: ['search_param'],
            filters: {}
        };
    },

    watch: {
        '$route.query'() {
            this.loadFromRoute();
        }
    },

    created() {
        this.loadFromRoute();
    },

    beforeDestroy() {
        clearTimeout(this.searchTimer);
    },

    methods: {
        loadFromRoute() {
            const count = toPositiveInt(this.$route.query.count, DEFAULT_COUNT);
            const page = toPositiveInt(this.$route.query.page, 1);

            // Normalize the URL so it always carries both params
            if (String(this.$route.query.count) !== String(count) || String(this.$route.query.page) !== String(page)) {
                this.$router.replace({ query: { ...this.$route.query, count, page } }).catch(() => {});
                return;
            }

            const filters = {};
            this.routeFilterKeys.forEach(key => {
                filters[key] = this.$route.query[key] || '';
            });

            this.perPage = count;
            this.currentPage = page;
            this.filters = filters;

            const active = {};
            Object.keys(filters).forEach(key => {
                if (filters[key]) active[key] = filters[key];
            });
            this.fetchPage({ count, page, ...active });
        },

        goToPage(page) {
            this.$router.push({ query: { ...this.$route.query, count: this.perPage, page } }).catch(() => {});
        },

        changePerPage(count) {
            this.$router.push({ query: { ...this.$route.query, count, page: 1 } }).catch(() => {});
        },

        // Writes the given filters to the route (empty values are dropped) and resets to page 1
        applyFilters(changes) {
            const query = { ...this.$route.query, ...changes, page: 1 };
            Object.keys(changes).forEach(key => {
                if (!changes[key]) delete query[key];
            });
            this.$router.push({ query }).catch(() => {});
        },

        onSearchInput() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.applyFilters({ search_param: (this.filters.search_param || '').trim() });
            }, SEARCH_DEBOUNCE_MS);
        },

        clearSearch() {
            clearTimeout(this.searchTimer);
            this.filters.search_param = '';
            this.applyFilters({ search_param: '' });
        }
    }
};
